import React from 'react';

const PresskitContent = () => (
  <p>
    Presskit Content
  </p>
);

export default PresskitContent;